import { render, staticRenderFns } from "./SignUpPassword.vue?vue&type=template&id=60af9aa8&"
import script from "./SignUpPassword.vue?vue&type=script&lang=js&"
export * from "./SignUpPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports